module.exports = __webpack_public_path__ + "img/new_age_03.e8e6df21.jpg";